import axios from "@/api/config_python";

/**
 * AI标题生成接口文档
 * @returns {Promise<{code:number,data:any,msg:string}>}
 */
export const videoTaskTitleGenerate = (params) => axios.post("/api/ai/video/generate_title", params);

/**
 * 创建AI视频任务接口
 * @returns {Promise<{code:number,data:any,msg:string}>}
 */
export const videoTaskCreate = (params) => axios.post("/api/ai/video/task/create", params);

/**
 * AI视频任务列表接口
 * @returns {Promise<{code:number,data:any,msg:string}>}
 */
export const getVideoTaskList = (params) => axios.get("/api/ai/video/task/lists", { params });

/**
 * 上传AI视频封面图片接口
 * @returns {Promise<{code:number,data:any,msg:string}>}
 */
export const videoCoverUpload = (params) => axios.post("/api/ai/video/cover/upload", params);

/**
 * AI视频任务详情接口
 * @returns {Promise<{code:number,data:any,msg:string}>}
 */
export const getVideoTaskDetail = (params) => axios.get("/api/ai/video/task/detail", { params });

/**
 * 查询AI视频状态接口
 * @returns {Promise<{code:number,data:any,msg:string}>}
 */
export const getVideoStatus = (params) => axios.get("/api/ai/video/status", { params });

/**
 * 更新ai视频任务标题接口
 * @returns {Promise<{code:number,data:any,msg:string}>}
 */
export const taskUpdateTitle = (params) => axios.post("/api/ai/video/task/update_title", params);

/**
 * 获取ai视频任务所有版本数据接口
 * @returns {Promise<{code:number,data:any,msg:string}>}
 */
export const getTaskVersions = (params) => axios.get("/api/ai/video/task/versions", { params });

/**
 * 查询AI视频任务预计花费接口
 * @returns {Promise<{code:number,data:any,msg:string}>}
 */
export const getVideoPrice = (params) => axios.get("/api/ai/video/task/price", { params });

/**
 * AI视频版本创建
 * @returns {Promise<{code:number,data:any,msg:string}>}
 */
export const videoVersionCreate = (params) => axios.post("/api/ai/video/version/create", params);

/**
 * AI素材模板接口
 * @returns {Promise<{code:number,data:any,msg:string}>}
 */
export const getVideoTemplate = (params) => axios.get("/api/ai/video/template/lists", { params });

/**
 * AI素材模板详情接口
 * @returns {Promise<{code:number,data:any,msg:string}>}
 */
export const getVideoTemplateDetail = (params) => axios.get("/api/ai/video/template/detail", { params });

/**
 * AI视频模板分类
 * @returns {Promise<{code:number,data:any,msg:string}>}
 */
export const getVideoTemplateCategories = (params) => axios.get("/api/ai/video/template/categories", { params });

/**
 * AI视频模板标签
 * @returns {Promise<{code:number,data:any,msg:string}>}
 */
export const getVideoTemplateTags = (params) => axios.get("/api/ai/video/template/tags/all", { params });
